import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import Logout from './pages/Logout';
import Snapshots from './pages/Snapshots';
import Topics from './pages/Topics';
import Questions from './pages/Questions';
import TopicForm from './pages/TopicForm';
import QuestionForm from './pages/QuestionForm';
import SnapshotForm from './pages/SnapshotForm';
import Users from './pages/Users'; // Import the Users component
import UserForm from './pages/UserForm'; // Import the UserForm component
import ProtectedRoute from './components/ProtectedRoute'; // Import the ProtectedRoute component
import Teams from './pages/Teams';
import TeamForm from './pages/TeamForm';
import SnapshotCompletionForm from './pages/SnapshotCompletionForm';
import SnapshotView from './pages/SnapshotView'; // Import the SurveyView component
import ChangePassword from './pages/ChangePassword'; // Import the ChangePassword component
import NotFound from './pages/NotFound';
import SnapshotResults from './pages/SnapshotResults'; // Import the SurveyResults component
import Settings from './pages/Settings'
import Organizations from './pages/Organizations';
import OrganizationsForm from './pages/OrganizationsForm';
import TriageResults from './pages/TriageResults'
import TriageStatus from './pages/TriageStatus'

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function App() {
  return (
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/logout"
          element={
            <ProtectedRoute>
              <Logout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/snapshots"
          element={
            <ProtectedRoute>
              <Snapshots />
            </ProtectedRoute>
          }
        />
        <Route
          path="/topics"
          element={
            <ProtectedRoute>
              <Topics />
            </ProtectedRoute>
          }
        />
        <Route
          path="/questions"
          element={
            <ProtectedRoute>
              <Questions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/topics/edit/:id"
          element={
            <ProtectedRoute>
              <TopicForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/topics/create"
          element={
            <ProtectedRoute>
              <TopicForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/questions/edit/:id"
          element={
            <ProtectedRoute>
              <QuestionForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/questions/create"
          element={
            <ProtectedRoute>
              <QuestionForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/snapshots/create"
          element={
            <ProtectedRoute>
              <SnapshotForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/snapshots/edit/:id"
          element={
            <ProtectedRoute>
              <SnapshotForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/snapshots/view/:snapshotId"
          element={
            <ProtectedRoute>
              <SnapshotView />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/snapshots/:snapshotId/triage/status"
          element={
            <ProtectedRoute>
              <TriageStatus />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/snapshots/:snapshotId/triage/:teamId"
          element={
            <ProtectedRoute>
              <TriageResults />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/create"
          element={
            <ProtectedRoute>
              <UserForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/edit/:id"
          element={
            <ProtectedRoute>
              <UserForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/teams"
          element={
            <ProtectedRoute>
              <Teams />
            </ProtectedRoute>
          }
        />
        <Route
          path="/teams/create"
          element={
            <ProtectedRoute>
              <TeamForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/teams/edit/:id"
          element={
            <ProtectedRoute>
              <TeamForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/organizations"
          element={
            <ProtectedRoute>
              <Organizations />
            </ProtectedRoute>
          }
        />
        <Route
          path="/organizations/create"
          element={
            <ProtectedRoute>
              <OrganizationsForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/organizations/edit/:id"
          element={
            <ProtectedRoute>
              <OrganizationsForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/complete/:snapshotId"
          element={
            <ProtectedRoute>
              <SnapshotCompletionForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/changepassword"
          element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/snapshots/:snapshotId/results"
          element={
            <ProtectedRoute>
              <SnapshotResults />
              </ProtectedRoute>
          }
        />
        <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
